/**
 * Page4 Component
 *
 * This component returns a page that contains a detailed description of the fourth item in the project list.
 */

import React from "react";

const Page4 = () => {
  return (
    <div className="page-content">
      <h2>Title 4</h2>
      <p>Additional content for the fourth item.</p>
    </div>
  );
};

export default Page4;
